import { render, staticRenderFns } from "./ConvivePage2.vue?vue&type=template&id=2264f20c&scoped=true&"
import script from "./ConvivePage2.vue?vue&type=script&lang=js&"
export * from "./ConvivePage2.vue?vue&type=script&lang=js&"
import style0 from "./ConvivePage2.vue?vue&type=style&index=0&id=2264f20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264f20c",
  null
  
)

export default component.exports